@if (this.isMobile) {
  <div class="position-sticky top-0 z-5">
    <div class="header-modal">
      @if (trigger) {
        <app-button btnType="icon" [cdkMenuTriggerFor]="trigger">
          <app-icon>menu</app-icon>
        </app-button>
      }
      @if (!trigger) {
        <img class="logo" src="/assets/svgs/logos/logo.svg" alt="logo" />
      }
      <div class="px-2 title">{{ title }}</div>
      <div class="close d-flex align-items-center justify-content-center">
        <app-icon (click)="onCloseClick()">close</app-icon>
      </div>
    </div>
    <mat-divider></mat-divider>
  </div>
}
